<template>
  <layout-home-header>
    <slot></slot>

    <template #footer>
      <the-footer />
    </template>
  </layout-home-header>
</template>

<script setup>
import TheFooter from '~/components/layouts/TheFooter.vue';
import LayoutHomeHeader from '~/layouts/LayoutHomeHeader.vue';
</script>
